module.exports = __webpack_public_path__ + "img/error_404bg.536ced6.jpg";